module.exports = {
  maxSignificantDigits: 12
};